export default __webpack_public_path__ + "static/media/menuLogo1.823e9dcf.png";